import { FieldProps } from "formik";
import React, { useEffect, useState, useCallback } from "react";
import { debounce } from "lodash";
import ReactSelect from "react-select";

export interface RemoteFetchProps {
	field?: FieldProps["field"];
	form?: FieldProps["form"];
	id: string;
	name: string;
	value?: string;
	className?: string;
	remoteUrl: string;
	remoteFetch: (fieldId: string, value: string, setRemoteData: (data: string[]) => void) => string[];
	fieldId: string;
}

const RemoteFetchInput: React.FC<RemoteFetchProps> = ({
	field,
	form,
	className,
	id,
	name,
	remoteUrl,
	remoteFetch,
	fieldId,
	...props
}) => {
	const [remoteData, setRemoteData] = useState<string[]>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	const debouncedFetch = useCallback(
		debounce((input: string) => {
			setIsLoading(true);
			remoteFetch(fieldId, input, setRemoteData);
		}, 600),
		[]
	);

	useEffect(() => {
		setIsLoading(false);
	}, [remoteData]);

	return (
		<div>
			<ReactSelect
				options={Array.isArray(remoteData) ? remoteData : []}
				{...field}
				isLoading={isLoading}
				name={(field && field.name) || name}
				value={(field && field.value) || props.value}
				onBlur={() => {
					form?.setFieldTouched(field?.name || name, true);
				}}
				onChange={(option: any, action) => {
					form?.setFieldValue(field?.name || name, option);
					if (action.action === "clear") {
						form?.setFieldValue(field?.name || name, "");
					}
				}}
				onInputChange={(value, action) => {
					if (action.action === "input-change") {
						debouncedFetch(value);
					}
				}}
				isClearable
				inputId={id}
				{...props}
				className={`react-select-container ${className}`}
				classNamePrefix="react-select"
				noOptionsMessage={() => "Start typing to begin your search"}
				menuPlacement={"auto"}
				maxMenuHeight={200}
			/>
		</div>
	);
};

export default RemoteFetchInput;
